// extracted by mini-css-extract-plugin
export default {"container":"NewBookForm_container__k1gH1","form":"NewBookForm_form__GC27C","button-group":"NewBookForm_button-group__VTl7u","btn-submit":"NewBookForm_btn-submit__IOpFw"};